import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Storefront from "@/pages/Storefront";
import SirenStream from "@/pages/SirenStream";
import BeautyCollege from "@/pages/BeautyCollege";
import SocialCommand from "@/pages/SocialCommand";
import Leaderboard from "@/pages/Leaderboard";
import CandidateProfile from "@/pages/CandidateProfile";
import ContestSuccess from "@/pages/ContestSuccess";
import AdmiralLogin from "@/pages/AdmiralLogin";
import AdmiralDashboard from "@/pages/AdmiralDashboard";
import GuardianDashboard from "@/pages/GuardianDashboard";
import AshairahFlagship from "@/pages/AshairahFlagship";
import Armada from "@/pages/Armada";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(10,10,10,0.95)",
              color: "#fff",
              border: "1px solid rgba(212,175,55,0.4)",
              borderRadius: 0,
              fontFamily: "Montserrat, sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/storefront" element={<Storefront />} />
            <Route path="/stream" element={<SirenStream />} />
            <Route path="/college" element={<BeautyCollege />} />
            <Route path="/social" element={<SocialCommand />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/armada" element={<Armada />} />
            <Route path="/candidates/:id" element={<CandidateProfile />} />
            <Route path="/contest/success" element={<ContestSuccess />} />
            <Route path="/admiral/login" element={<AdmiralLogin />} />
            <Route path="/admiral" element={<AdmiralDashboard />} />
            <Route path="/guardian" element={<GuardianDashboard />} />
            {/* Ashairah Kirk — Sovereign Heir Flagship */}
            <Route path="/junior" element={<AshairahFlagship />} />
            <Route path="/junior/:id" element={<CandidateProfile />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
